module.exports = __webpack_public_path__ + "img/logo-text.5a70db04.svg";